import ar from "./ar.json";
import en from "./en.json";
import de from "./de.json";

export const dictionaryList = { en, ar, de };
